import {
  BreadcrumbCurrentLink,
  BreadcrumbRoot,
  Heading,
  PageHeader,
  PageTitle,
  Stack,
  Text,
} from '@oaknorth/component-core-v2';
import { T, useTranslation } from '@oaknorth/util-intl';
import { ResponsivePageContainer } from '@oaknorth/util-responsive';
import { Helmet, LinkButton } from '@oaknorth/util-routing';

export function Diagnostics() {
  const { t } = useTranslation();
  const title = t`diagnostics.title`;

  return (
    <ResponsivePageContainer
      nav={
        <BreadcrumbRoot>
          <BreadcrumbCurrentLink isHomePage>{title}</BreadcrumbCurrentLink>
        </BreadcrumbRoot>
      }
    >
      <PageHeader>
        <Helmet title={title} />
        <PageTitle>{title}</PageTitle>
      </PageHeader>
      <Stack width="sm" marginTop={8} gap={16}>
        <Stack gap={3}>
          <Heading as="h2" size="lg">{T`diagnostics.excludedBorrowers.heading`}</Heading>
          <Text fontSize="lg"> {T`diagnostics.excludedBorrowers.description`}</Text>
          <LinkButton
            width="fit-content"
            variant="solid"
            to="/diagnostics/excluded-borrowers"
          >{T`diagnostics.excludedBorrowers.button`}</LinkButton>
        </Stack>

        <Stack gap={3}>
          <Heading as="h2" size="lg">{T`diagnostics.support.heading`}</Heading>
          <Text fontSize="lg">{T`diagnostics.support.description`}</Text>
          <LinkButton width="fit-content" variant="solid" to="/support">
            {T`diagnostics.support.button`}
          </LinkButton>
        </Stack>
      </Stack>
    </ResponsivePageContainer>
  );
}
